/**
 * @generated SignedSource<<064dd78240d7f47985b4dab3a8e625f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MarkdownBlock_contentBlock$data = {
  readonly markdown: string;
  readonly " $fragmentType": "MarkdownBlock_contentBlock";
};
export type MarkdownBlock_contentBlock$key = {
  readonly " $data"?: MarkdownBlock_contentBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"MarkdownBlock_contentBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MarkdownBlock_contentBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "markdown",
      "storageKey": null
    }
  ],
  "type": "MarkdownBlock",
  "abstractKey": null
};

(node as any).hash = "2250fc46c6560cba7bbddcbbc18ecff0";

export default node;
